import * as Yup from "yup";
import parsePhoneNumberFromString from "libphonenumber-js";
import dayjs from "dayjs";

export const SellerStep1Schema = Yup.object({
  name: Yup.string().required("Name is required"),
  phone: Yup.string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;

      try {
        const phoneNumber = parsePhoneNumberFromString(value);
        return phoneNumber?.isValid() || false;
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

export const SellerStep5Schema = Yup.object({
  meetingTime: Yup.mixed()
    .test("is-valid", "Please enter a valid date and time", (value) => {
      return value && dayjs(value).isValid();
    })
    .required("Date and time is required"),
});

export const PropDetailsSchema = Yup.object({
  lookingfor: Yup.string().required("Please select an option"),
  interestedIn: Yup.string().required("Please select an option"),
  propertyClass: Yup.string().required("Please select an option"),
  transact: Yup.string().required("Please select an option"),
  priceRange: Yup.string().required("Please select an option"),
});
